import React from 'react'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Collapse from 'components_new/atoms/Collapse'
import Grid from 'components_new/atoms/Grid'
import Text from 'components_new/atoms/Text'

import CardOption from 'components_new/molecules/CardOption'

import {
  ISelectMetric,
  TCustomEconomyMetricVariant,
  isCustomEconomyMetric
} from 'types/GlobalMetric'
import { VARIANT_SUBCATEGORY_ORDER } from 'utils/metric'
import type { Step } from '../lib'

interface Props {
  step: Step
  metric: ISelectMetric
  variant: string | null
  setVariant: (v: string | null) => void
}

const VariantStep = ({ step, metric, variant, setVariant }: Props) => {
  const { lang } = useTranslation()

  if (!isCustomEconomyMetric(metric)) return null

  const groups = metric.variants.reduce<
    Record<string, TCustomEconomyMetricVariant[]>
  >((acc, m) => {
    const key = m.subcategory.slug

    if (!acc[key]) acc[key] = []
    acc[key].push(m)

    return acc
  }, {})

  const sortedGroups = Object.values(groups).sort((a, b) => {
    const slugA = a[0].subcategory.slug
    const slugB = b[0].subcategory.slug
    const indexA = VARIANT_SUBCATEGORY_ORDER.indexOf(slugA)
    const indexB = VARIANT_SUBCATEGORY_ORDER.indexOf(slugB)

    if (indexA !== -1 && indexB !== -1) return indexA - indexB
    if (indexA !== -1) return -1
    if (indexB !== -1) return 1

    return slugA.localeCompare(slugB)
  })

  return (
    <Collapse in={step === 'variant'}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {sortedGroups.map((groupMetrics) => (
          <Box key={groupMetrics[0].subcategory.slug}>
            <Text
              variant="overline"
              color="text.secondary"
              sx={{ display: 'block', mb: 1 }}
            >
              {groupMetrics[0].subcategory.title[lang]}
            </Text>
            <Grid container={true} spacing={1}>
              {groupMetrics.map((m) => (
                <Grid item={true} key={m.id} xs={4}>
                  <CardOption
                    id={m.id}
                    active={variant === m.id}
                    title={m.title[lang]}
                    onChange={() => setVariant(m.id)}
                    sx={{ height: '100%' }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Box>
    </Collapse>
  )
}

export default VariantStep
